var _window$document;

import * as React from 'react';

var getRefElement = function getRefElement(element) {
  if (element && "current" in element) {
    return element.current;
  }

  return element;
};

var isSsr = !(typeof window !== "undefined" && ((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.createElement));

function useEventListener(_ref) {
  var type = _ref.type,
      listener = _ref.listener,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? isSsr ? void 0 : window : _ref$element,
      options = _ref.options;
  var savedListener = React.useRef();
  React.useEffect(function () {
    savedListener.current = listener;
  }, [listener]);
  var handleEventListener = React.useCallback(function (event) {
    var _savedListener$curren;

    (_savedListener$curren = savedListener.current) === null || _savedListener$curren === void 0 ? void 0 : _savedListener$curren.call(savedListener, event);
  }, []);
  React.useEffect(function () {
    var target = getRefElement(element);
    target === null || target === void 0 ? void 0 : target.addEventListener(type, handleEventListener, options);
    return function () {
      return target === null || target === void 0 ? void 0 : target.removeEventListener(type, handleEventListener);
    };
  }, [type, element, options, handleEventListener]);
}

export { getRefElement, useEventListener };